// extracted by mini-css-extract-plugin
export var locationCard = "_ft-0";